import { connect } from 'react-redux'
import { compose, lifecycle } from 'recompose'
import Notification from '../../components/notification/notificationComponent'
import { State } from '../../redux/reducers/'
import { actionCreators } from '../../redux/reducers/ui/uiReducer'

// Global State
export function mapStateToProps (state: State, props): Values {
  return {
    notification: state.ui.notification
  }
}
// In Object form, each funciton is automatically wrapped in a dispatch
export const propsMapping: Callbacks = {
  changeNotification: actionCreators.changeNotification,
  onClick: actionCreators.toggleNotificationModal
}

export default compose(
  connect(mapStateToProps, propsMapping),
  lifecycle({
    componentWillUnmount: function () {
      if (this.props.resetNotification) {
        this.props.changeNotification({})
      }
    }
  })
)(Notification)



// WEBPACK FOOTER //
// ./src/containers/notification/notificationContainer.js